export function gppInRequest(params = {}) {
    return {
        type: '@postoplanejamentogpp/GPP_IN_REQUEST',
        payload: { params },
    };
}

export function failedRequest() {
    return {
        type: '@postoplanejamentogpp/FAILED_REQUEST',
    };
}

export function successInRequest(
    gpp,
    page,
    pageSize,
    totalCount,
    totalPages
) {
    return {
        type: '@postoplanejamentogpp/SUCCESS_IN_REQUEST',
        payload: { gpp, page, pageSize, totalCount, totalPages },
    };
}

export function successRequest(gpp) {
    return {
        type: '@postoplanejamentogpp/SUCCESS_REQUEST',
        payload: { gpp },
    };
}



export function recordFiltering(params) {
    return {
        type: '@postoplanejamentogpp/RECORD_FILTERING',
        payload: { params },
    };
}
